import type {
  VetCanStudioStep,
  VetCanStudioStepId,
  VetCanStudioStepState,
} from "../../lib/studio/studioReadModel";

function stateColors(state: VetCanStudioStepState) {
  if (state === "blocked") {
    return {
      dot: "#a23e3e",
      pill: "rgba(162, 62, 62, 0.12)",
      text: "#812d2d",
    };
  }
  if (state === "draft") {
    return {
      dot: "#8f6e16",
      pill: "rgba(181, 141, 34, 0.14)",
      text: "#6d5210",
    };
  }
  return {
    dot: "#2c5d43",
    pill: "rgba(44, 93, 67, 0.14)",
    text: "#214735",
  };
}

export default function StudioStepRail(props: {
  steps: VetCanStudioStep[];
  activeStepId: VetCanStudioStepId;
  onSelectStep: (stepId: VetCanStudioStepId) => void;
}) {
  return (
    <nav aria-label="VetCan Studio steps">
      <div
        style={{
          display: "grid",
          gap: "0.75rem",
        }}
      >
        {props.steps.map((step, index) => {
          const active = step.id === props.activeStepId;
          const colors = stateColors(step.state);

          return (
            <button
              key={step.id}
              type="button"
              onClick={() => props.onSelectStep(step.id)}
              aria-current={active ? "step" : undefined}
              style={{
                textAlign: "left",
                borderRadius: 22,
                border: active
                  ? "1px solid rgba(41, 84, 103, 0.32)"
                  : "1px solid rgba(54, 44, 35, 0.1)",
                background: active
                  ? "linear-gradient(180deg, rgba(239, 248, 252, 0.98), rgba(251, 253, 254, 0.98))"
                  : "rgba(255, 252, 248, 0.92)",
                padding: "0.95rem 1rem",
                cursor: "pointer",
                boxShadow: active
                  ? "0 18px 40px rgba(41, 84, 103, 0.12)"
                  : "0 14px 28px rgba(77, 61, 44, 0.06)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "0.75rem",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                }}
              >
                <span
                  style={{
                    fontSize: "0.75rem",
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    color: "#7b726a",
                    fontWeight: 700,
                  }}
                >
                  Step {index + 1}
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.4rem",
                    padding: "0.24rem 0.58rem",
                    borderRadius: 999,
                    background: colors.pill,
                    color: colors.text,
                    fontSize: "0.74rem",
                    fontWeight: 700,
                    textTransform: "capitalize",
                  }}
                >
                  <span
                    aria-hidden="true"
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: 999,
                      background: colors.dot,
                    }}
                  />
                  {step.state}
                </span>
              </div>
              <div style={{ fontSize: "1rem", fontWeight: 700, color: "#23201d" }}>
                {step.title}
              </div>
              <p
                style={{
                  margin: "0.45rem 0 0",
                  fontSize: "0.9rem",
                  color: "#5e564f",
                  lineHeight: 1.45,
                }}
              >
                {step.summary}
              </p>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
